import React, { Component } from 'react';
import * as firebase from 'firebase';
import MetaTags from 'react-meta-tags';
import scrollToComponent from 'react-scroll-to-component';
import ReactDOM from 'react-dom';
import Login from '../View/Login';
import BG from '../images/table1IconBg.svg';
import '../css/table.css'

import {
  ShareButtons,
  generateShareIcon
} from 'react-share';
const {
  FacebookShareButton,
  GooglePlusShareButton
} = ShareButtons;

const FacebookIcon = generateShareIcon('facebook');
const GooglePlusIcon = generateShareIcon('google');


class Table1 extends Component {
  constructor(props, context) {
    super(props, context)
    this.state = {
      send: false,
      loading: false,
      ans1: false,
      ans2: false,
      ans3: false,
      ans4: false,
      ans5: false,
      ans6: false,
      ans7: false,
      ans8: false,
      ans9: false,
      ans10: false,
      ans11: false,
      ans12: false,
      ans13: false,
      ans14: false,
      ans15: false,
      ans16: false,
      name: '亞健康自我診斷',
      totalTest:'',
      photoURL: '',
      url: 'herbalcure.com.tw/Table1',
      thumb: 'https://firebasestorage.googleapis.com/v0/b/herbal-cure.appspot.com/o/newThumb%2Ftable1.jpg?alt=media&token=51167fff-7bb7-4433-9a3b-26fecde8a84e',
      fbthumb: 'https://firebasestorage.googleapis.com/v0/b/herbal-cure.appspot.com/o/newThumb%2Ftable1.jpg?alt=media&token=51167fff-7bb7-4433-9a3b-26fecde8a84e'
    }
    this.tableBox = this.tableBox.bind(this);
    this.handleChangeAns1 = this.handleChangeAns1.bind(this);
    this.handleChangeAns2 = this.handleChangeAns2.bind(this);
    this.handleChangeAns3 = this.handleChangeAns3.bind(this);
    this.handleChangeAns4 = this.handleChangeAns4.bind(this);
    this.handleChangeAns5 = this.handleChangeAns5.bind(this);
    this.handleChangeAns6 = this.handleChangeAns6.bind(this);
    this.handleChangeAns7 = this.handleChangeAns7.bind(this);
    this.handleChangeAns8 = this.handleChangeAns8.bind(this);
    this.handleChangeAns9 = this.handleChangeAns9.bind(this);
    this.handleChangeAns10 = this.handleChangeAns10.bind(this);
    this.handleChangeAns11 = this.handleChangeAns11.bind(this);
    this.handleChangeAns12 = this.handleChangeAns12.bind(this);
    this.handleChangeAns13 = this.handleChangeAns13.bind(this);
    this.handleChangeAns14 = this.handleChangeAns14.bind(this);
    this.handleChangeAns15 = this.handleChangeAns15.bind(this);
    this.handleChangeAns16 = this.handleChangeAns16.bind(this);
    this.goToTable2 = this.goToTable2.bind(this);
    this.goToTable3 = this.goToTable3.bind(this);
    this.goToTable4 = this.goToTable4.bind(this);
    this.goToTable5 = this.goToTable5.bind(this);
    this.tableSave = this.tableSave.bind(this);
  }
  componentDidMount() {
    window.scrollTo(0,0);
    const tableBox = ReactDOM.findDOMNode(this.refs.tableBox);
    firebase.auth().onAuthStateChanged((user) => {
      if(user) {
        tableBox.classList.add('isShow')
        const totalTestTableRef = firebase.database().ref().child('total')
        totalTestTableRef.on('value', snap => {
          this.setState({
            totalTest: snap.val().totalTest
          })
        })
       console.log(this.state.totalTest)
      } else {
        tableBox.classList.remove('isShow')
      }
    })
  }
  tableBox() {
    const tableBox = ReactDOM.findDOMNode(this.refs.tableBox);
    firebase.auth().onAuthStateChanged((user) => {
      if(user) {
        tableBox.classList.add('isShow')
        scrollToComponent(tableBox, {
        	offset: -50,
        	align: 'top',
        	duration: 700
        })
      } else {
        tableBox.classList.remove('isShow')
        this.setState({ send: true})
        setTimeout(() => this.setState({ loading: true }), 400);
        // window.location = ('/Login')
        // this.props.history.push('/Login');
      }
    })
  }
  goToTable2() {
    const table1 = ReactDOM.findDOMNode(this.refs.table1);
    const table2 = ReactDOM.findDOMNode(this.refs.table2);
    const tableBox = ReactDOM.findDOMNode(this.refs.tableBox);
    const sliderBar = ReactDOM.findDOMNode(this.refs.sliderBar);
    scrollToComponent(tableBox, {
      offset: -50,
      align: 'top',
      duration: 700
    })
    table1.classList.remove('isShow');
    table2.classList.add('isShow');
    sliderBar.classList.add('is20');
  }
  goToTable3() {
    const table2 = ReactDOM.findDOMNode(this.refs.table2);
    const table3 = ReactDOM.findDOMNode(this.refs.table3);
    const tableBox = ReactDOM.findDOMNode(this.refs.tableBox);
    const sliderBar = ReactDOM.findDOMNode(this.refs.sliderBar);
    scrollToComponent(tableBox, {
      offset: -50,
      align: 'top',
      duration: 700
    })
    table2.classList.remove('isShow');
    table3.classList.add('isShow');
    sliderBar.classList.add('is40');
  }
  goToTable4() {
    const table3 = ReactDOM.findDOMNode(this.refs.table3);
    const table4 = ReactDOM.findDOMNode(this.refs.table4);
    const tableBox = ReactDOM.findDOMNode(this.refs.tableBox);
    const sliderBar = ReactDOM.findDOMNode(this.refs.sliderBar);
    scrollToComponent(tableBox, {
      offset: -50,
      align: 'top',
      duration: 700
    })
    table3.classList.remove('isShow');
    table4.classList.add('isShow');
    sliderBar.classList.add('is60');
  }
  goToTable5() {
    const table4 = ReactDOM.findDOMNode(this.refs.table4);
    const table5 = ReactDOM.findDOMNode(this.refs.table5);
    const tableBox = ReactDOM.findDOMNode(this.refs.tableBox);
    const sliderBar = ReactDOM.findDOMNode(this.refs.sliderBar);
    scrollToComponent(tableBox, {
      offset: -50,
      align: 'top',
      duration: 700
    })
    table4.classList.remove('isShow');
    table5.classList.add('isShow');
    sliderBar.classList.add('is80');
  }

  tableSave(event) {
    event.preventDefault()
    const totalTestTableRef = firebase.database().ref().child('total');
    totalTestTableRef.update({
      totalTest: (this.state.totalTest * 1) + 1
    })
    const sliderBar = ReactDOM.findDOMNode(this.refs.sliderBar);
    sliderBar.classList.add('is100');
    const userId = firebase.auth().currentUser.uid;
    const rootRef = firebase.database().ref('users/').child(userId).child('Answers').push();
    const postId = rootRef.key;
    const total = ((this.state.ans1 * 1) + (this.state.ans2 * 1) + (this.state.ans3 * 1) + (this.state.ans4 * 1) + (this.state.ans5 * 1) + (this.state.ans6 * 1) + (this.state.ans7 * 1) + (this.state.ans8 * 1) + (this.state.ans9 * 1) + (this.state.ans10 * 1) + (this.state.ans11 * 1) + (this.state.ans12 * 1) + (this.state.ans13 * 1) + (this.state.ans14 * 1) + (this.state.ans15 * 1) + (this.state.ans16 * 1))
    if(total < 50) {
      rootRef.update({
        Reviews: '恭喜您沒有亞健康的狀況，要繼續努力保持喔。',
        ans: total,
        name: '亞健康自我診斷',
        createDate: new Date().toLocaleDateString(),
        createTime: new Date().toLocaleTimeString(),
        id: postId,
        url: 'herbalcure.com.tw/Table1',
        localUrl: '/Table1',
        thumb: 'https://firebasestorage.googleapis.com/v0/b/herbal-cure.appspot.com/o/newThumb%2Ftable1.jpg?alt=media&token=51167fff-7bb7-4433-9a3b-26fecde8a84e',
        fbthumb: 'https://firebasestorage.googleapis.com/v0/b/herbal-cure.appspot.com/o/newThumb%2Ftable1.jpg?alt=media&token=51167fff-7bb7-4433-9a3b-26fecde8a84e'
      })
    } else if (total < 80) {
      rootRef.update({
        Reviews: '你有中等程度的亞健康狀況，身體在發出警訊了，是否安靜坐下來，好好反思你的生活狀態，加強身體運動和營養搭配等等方法。',
        ans: total,
        name: '亞健康自我診斷',
        createDate: new Date().toLocaleDateString(),
        createTime: new Date().toLocaleTimeString(),
        id: postId,
        url: 'herbalcure.com.tw/Table1',
        localUrl: '/Table1',
        thumb: 'https://firebasestorage.googleapis.com/v0/b/herbal-cure.appspot.com/o/newThumb%2Ftable1.jpg?alt=media&token=51167fff-7bb7-4433-9a3b-26fecde8a84e',
        fbthumb: 'https://firebasestorage.googleapis.com/v0/b/herbal-cure.appspot.com/o/newThumb%2Ftable1.jpg?alt=media&token=51167fff-7bb7-4433-9a3b-26fecde8a84e'
      })
    } else {
      rootRef.update({
        Reviews: '您的亞健康程度已經是高危險群了，需要到醫院做檢測或是找專業醫師進行諮詢。',
        ans: total,
        name: '亞健康自我診斷',
        createDate: new Date().toLocaleDateString(),
        createTime: new Date().toLocaleTimeString(),
        id: postId,
        url: 'herbalcure.com.tw/Table1',
        localUrl: '/Table1',
        thumb: 'https://firebasestorage.googleapis.com/v0/b/herbal-cure.appspot.com/o/newThumb%2Ftable1.jpg?alt=media&token=51167fff-7bb7-4433-9a3b-26fecde8a84e',
        fbthumb: 'https://firebasestorage.googleapis.com/v0/b/herbal-cure.appspot.com/o/newThumb%2Ftable1.jpg?alt=media&token=51167fff-7bb7-4433-9a3b-26fecde8a84e'
      })
    }
    window.location = ('/Answer/' + postId);
  }
  handleChangeAns1(event) {
    this.setState({ans1: event.target.value});
    const toQ2 = ReactDOM.findDOMNode(this.refs.toQ2);
    scrollToComponent(toQ2, {
      offset: 150,
      align: 'top',
      duration: 700
    })
  }
  handleChangeAns2(event) {
    this.setState({ans2: event.target.value});
    const toQ3 = ReactDOM.findDOMNode(this.refs.toQ3);
    scrollToComponent(toQ3, {
      offset: 150,
      align: 'top',
      duration: 700
    })
  }
  handleChangeAns3(event) {
    this.setState({ans3: event.target.value});
    const toNext1 = ReactDOM.findDOMNode(this.refs.toNext1);
    scrollToComponent(toNext1, {
      offset: 150,
      align: 'top',
      duration: 700
    })
  }
  handleChangeAns4(event) {
    this.setState({ans4: event.target.value});
    const toQ5 = ReactDOM.findDOMNode(this.refs.toQ5);
    scrollToComponent(toQ5, {
      offset: 150,
      align: 'top',
      duration: 700
    })
  }
  handleChangeAns5(event) {
    this.setState({ans5: event.target.value});
    const toQ6 = ReactDOM.findDOMNode(this.refs.toQ6);
    scrollToComponent(toQ6, {
      offset: 150,
      align: 'top',
      duration: 700
    })
  }
  handleChangeAns6(event) {
    this.setState({ans6: event.target.value});
    const toNext2 = ReactDOM.findDOMNode(this.refs.toNext2);
    scrollToComponent(toNext2, {
      offset: 150,
      align: 'top',
      duration: 700
    })
  }
  handleChangeAns7(event) {
    this.setState({ans7: event.target.value});
    const toQ8 = ReactDOM.findDOMNode(this.refs.toQ8);
    scrollToComponent(toQ8, {
      offset: 150,
      align: 'top',
      duration: 700
    })
  }
  handleChangeAns8(event) {
    this.setState({ans8: event.target.value});
    const toQ9 = ReactDOM.findDOMNode(this.refs.toQ9);
    scrollToComponent(toQ9, {
      offset: 150,
      align: 'top',
      duration: 700
    })
  }
  handleChangeAns9(event) {
    this.setState({ans9: event.target.value});
    const toNext3 = ReactDOM.findDOMNode(this.refs.toNext3);
    scrollToComponent(toNext3, {
      offset: 150,
      align: 'top',
      duration: 700
    })
  }
  handleChangeAns10(event) {
    this.setState({ans10: event.target.value});
    const toQ11 = ReactDOM.findDOMNode(this.refs.toQ11);
    scrollToComponent(toQ11, {
      offset: 150,
      align: 'top',
      duration: 700
    })
  }
  handleChangeAns11(event) {
    this.setState({ans11: event.target.value});
    const toQ12 = ReactDOM.findDOMNode(this.refs.toQ12);
    scrollToComponent(toQ12, {
      offset: 150,
      align: 'top',
      duration: 700
    })
  }
  handleChangeAns12(event) {
    this.setState({ans12: event.target.value});
    const toNext4 = ReactDOM.findDOMNode(this.refs.toNext4);
    scrollToComponent(toNext4, {
      offset: 150,
      align: 'top',
      duration: 700
    })
  }
  handleChangeAns13(event) {
    this.setState({ans13: event.target.value});
    const toQ14 = ReactDOM.findDOMNode(this.refs.toQ14);
    scrollToComponent(toQ14, {
      offset: 150,
      align: 'top',
      duration: 700
    })
  }
  handleChangeAns14(event) {
    this.setState({ans14: event.target.value});
    const toQ15 = ReactDOM.findDOMNode(this.refs.toQ15);
    scrollToComponent(toQ15, {
      offset: 150,
      align: 'top',
      duration: 700
    })
  }
  handleChangeAns15(event) {
    this.setState({ans15: event.target.value});
    const toQ16 = ReactDOM.findDOMNode(this.refs.toQ16);
    scrollToComponent(toQ16, {
      offset: 150,
      align: 'top',
      duration: 700
    })
  }
  handleChangeAns16(event) {
    this.setState({ans16: event.target.value});
    const toNext5 = ReactDOM.findDOMNode(this.refs.toNext5);
    scrollToComponent(toNext5, {
      offset: 150,
      align: 'top',
      duration: 700
    })
  }
  render(postId) {
    const { loading } = this.state;
    if(loading) {
      return <div style={{display: this.state.send ? 'flex' : 'none', background: '#eeede9',justifyContent: 'center', alignItems:'center'}} >
        <Login />
      </div>
    }
    const nextBtn1 = ((this.state.ans1 + this.state.ans2 + this.state.ans3) * 1)
     ? <div className="nextTablebtnDefault" onClick={this.goToTable2}>下一題</div>
     : null
    const nextBtn2 = ((this.state.ans4 + this.state.ans5 + this.state.ans6) * 1)
     ? <div className="nextTablebtnDefault" onClick={this.goToTable3}>下一題</div>
     : null
    const nextBtn3 = ((this.state.ans7 + this.state.ans8 + this.state.ans9) * 1)
     ? <div className="nextTablebtnDefault" onClick={this.goToTable4}>再接再厲</div>
     : null
    const nextBtn4 = ((this.state.ans10 + this.state.ans11 + this.state.ans12) * 1)
     ? <div className="nextTablebtnDefault" onClick={this.goToTable5}>下一題</div>
     : null
    const nextBtn5 = ((this.state.ans13 + this.state.ans14 + this.state.ans15 + this.state.ans16) * 1)
     ? <div className="nextTablebtnDefault" onClick={this.tableSave}>完成!提交吧</div>
     : null

    return (
      <div>
        <MetaTags>
            <title>草學藥事 || {this.state.name}</title>
            <meta id="og-title" property="og:title" content={this.state.name} />
        </MetaTags>
        <div className="animationBox" style={Jeyu.Banner} ref="banner">
         <div className="container">
          <div className="row">
          <div style={Jeyu.Slogan} className="slogan table1">
           <h1>你有亞健康症狀嗎?</h1>
           <h2>快速檢測 了解自己</h2>
           <p className="moileNone">
           你知道全球有75%的人處於亞健康狀態嗎?<br />
           身體沒有疾病但卻時常感覺身心疲憊不舒服<br />
           透過自我檢測來追求健康人生吧!
           </p>
           <span className="tableBtnDefault" onClick={this.tableBox}>開始檢測</span>
           <article className="fbBox">
                  <div className="Demo__some-network">
                     <FacebookShareButton
                       url='https://herbalcure.com.tw/Table1'
                       quote={this.state.name}
                       className="Demo__some-network__share-button">
                       <FacebookIcon
                         size={26}
                         round />
                     </FacebookShareButton>
                   </div>
                   <div className="Demo__some-network">
                     <GooglePlusShareButton
                       url='https://herbalcure.com.tw/Table1'
                       className="Demo__some-network__share-button">
                       <GooglePlusIcon
                         size={26}
                         round />
                     </GooglePlusShareButton>
                   </div>
           </article>
          </div>
          </div>
         </div>
        </div>
        <div className="tableBox table2Height" ref="tableBox" style={Jeyu.tableBox}>
         <div className="container">
          <div className="row">
           <div className="tableFlexBox">
           <div className="mobilePd20">
            <h2>亞健康自我診斷</h2>
            <sub>拒絕當亞健康一族從自我檢測開始<br />
             請您根據最近一星期內以來身體與情緒的真正感覺，勾選最符合的一項!
            </sub>
           </div>
            <div className="sliderBar" ref="sliderBar"></div>
            <section className="">
             <form className="tableForm">
              <div className="table1 isShow" ref="table1">
              <article ref="toQ2">
               <h1>Q1:早上起床時，常有頭髮掉落?</h1>
               <input type="radio" value='5'
                id="ans1"
                checked={this.state.ans1 === '5'}
                onChange={this.handleChangeAns1} />
               <label htmlFor="ans1">是</label>
               <input type="radio" value='1'
                id="ans2"
                checked={this.state.ans1 === '1'}
                onChange={this.handleChangeAns1} />
               <label htmlFor="ans2">否</label>
              </article>
              <article ref="toQ3">
               <h1>Q2:情緒有些抑鬱，常對窗外發呆?</h1>
               <input type="radio" value='5'
                id="ans3"
                checked={this.state.ans2 === '5'}
                onChange={this.handleChangeAns2} />
               <label htmlFor="ans3">是</label>
               <input type="radio" value='1'
                id="ans4"
                checked={this.state.ans2 === '1'}
                onChange={this.handleChangeAns2} />
               <label htmlFor="ans4">否</label>
              </article>
              <article ref="toNext1">
               <h1>Q3:害怕走進辦公室，厭倦工作?</h1>
               <input type="radio" value='5'
                id="ans5"
                checked={this.state.ans3 === '5'}
                onChange={this.handleChangeAns3} />
               <label htmlFor="ans5">是</label>
               <input type="radio" value='1'
                id="ans6"
                checked={this.state.ans3 === '1'}
                onChange={this.handleChangeAns3} />
               <label htmlFor="ans6">否</label>
              </article>
              <div>{ nextBtn1 }</div>
              </div>
              <div className="table2" ref="table2">
              <article ref="toQ5">
               <h1>Q4:不想面對同事，有自閉症趨勢?</h1>
               <input type="radio" value='5'
                id="ans7"
                checked={this.state.ans4 === '5'}
                onChange={this.handleChangeAns4} />
               <label htmlFor="ans7">是</label>
               <input type="radio" value='1'
                id="ans8"
                checked={this.state.ans4 === '1'}
                onChange={this.handleChangeAns4} />
               <label htmlFor="ans8">否</label>
              </article>
              <article ref="toQ6">
               <h1>Q5:工作效率不高，上司已對你不滿?</h1>
               <input type="radio" value='5'
                id="ans9"
                checked={this.state.ans5 === '5'}
                onChange={this.handleChangeAns5} />
               <label htmlFor="ans9">是</label>
               <input type="radio" value='1'
                id="ans10"
                checked={this.state.ans5 === '1'}
                onChange={this.handleChangeAns5} />
               <label htmlFor="ans10">否</label>
              </article>
              <article ref="toNext2">
               <h1>Q6:工作1小時，身體倦怠，胸悶氣短?</h1>
               <input type="radio" value='10'
                id="ans11"
                checked={this.state.ans6 === '10'}
                onChange={this.handleChangeAns6} />
               <label htmlFor="ans11">是</label>
               <input type="radio" value='1'
                id="ans12"
                checked={this.state.ans6 === '1'}
                onChange={this.handleChangeAns6} />
               <label htmlFor="ans12">否</label>
              </article>
              <div>{ nextBtn2 }</div>
              </div>
              <div className="table3" ref="table3">
              <article ref="toQ8">
               <h1>Q7:昨天想好的事，今天怎麼也記不起來了，而且近些天來，經常出現這種情況 ?</h1>
               <input type="radio" value='10'
                id="ans13"
                checked={this.state.ans7 === '10'}
                onChange={this.handleChangeAns7} />
               <label htmlFor="ans13">是</label>
               <input type="radio" value='1'
                id="ans14"
                checked={this.state.ans7 === '1'}
                onChange={this.handleChangeAns7} />
               <label htmlFor="ans14">否</label>
              </article>
              <article ref="toQ9">
               <h1>Q8:工作情緒始終無法高漲，最令自己不解的是:無名火氣很大，但又沒有精力發作?</h1>
               <input type="radio" value='5'
                id="ans15"
                checked={this.state.ans8 === '5'}
                onChange={this.handleChangeAns8} />
               <label htmlFor="ans15">是</label>
               <input type="radio" value='1'
                id="ans16"
                checked={this.state.ans8 === '1'}
                onChange={this.handleChangeAns8} />
               <label htmlFor="ans16">否</label>
              </article>
              <article ref="toNext3">
               <h1>Q9:一日三餐，進餐甚少，排除天氣因素，即使胃口適合自己的菜，近來也如同嚼蠟?</h1>
               <input type="radio" value='5'
                id="ans17"
                checked={this.state.ans9 === '5'}
                onChange={this.handleChangeAns9} />
               <label htmlFor="ans17">是</label>
               <input type="radio" value='1'
                id="ans18"
                checked={this.state.ans9 === '1'}
                onChange={this.handleChangeAns9} />
               <label htmlFor="ans18">否</label>
              </article>
              <div>{ nextBtn3 }</div>
              </div>
              <div className="table4" ref="table4">
              <article ref="toQ11">
               <h1>Q10:盼望早早地逃離辦公室，為的是能夠回家躺在床上休息片刻?</h1>
               <input type="radio" value='5'
                id="ans19"
                checked={this.state.ans10 === '5'}
                onChange={this.handleChangeAns10} />
               <label htmlFor="ans19">是</label>
               <input type="radio" value='1'
                id="ans20"
                checked={this.state.ans10 === '1'}
                onChange={this.handleChangeAns10} />
               <label htmlFor="ans20">否</label>
              </article>
              <article ref="toQ12">
               <h1>Q11:對城市的汙染、噪音非常敏感，比常人更渴望清幽、寧靜的山水，休息身心?</h1>
               <input type="radio" value='5'
                id="ans21"
                checked={this.state.ans11 === '5'}
                onChange={this.handleChangeAns11} />
               <label htmlFor="ans21">是</label>
               <input type="radio" value='1'
                id="ans22"
                checked={this.state.ans11 === '1'}
                onChange={this.handleChangeAns11} />
               <label htmlFor="ans22">否</label>
              </article>
              <article ref="toNext4">
               <h1>Q12:不再像以前那樣熱衷於朋友的聚會，有種強打精神、勉強應酬的感覺?</h1>
               <input type="radio" value='5'
                id="ans23"
                checked={this.state.ans12 === '5'}
                onChange={this.handleChangeAns12} />
               <label htmlFor="ans23">是</label>
               <input type="radio" value='1'
                id="ans24"
                checked={this.state.ans12 === '1'}
                onChange={this.handleChangeAns12} />
               <label htmlFor="ans24">否</label>
              </article>
              <div>{ nextBtn4 }</div>
              </div>
              <div className="table5" ref="table5">
              <article ref="toQ14">
               <h1>Q13:晚上經常睡不著覺，即使睡著了，又老是在做夢的狀態中，睡眠質量糟糕?</h1>
               <input type="radio" value='10'
                id="ans25"
                checked={this.state.ans13 === '10'}
                onChange={this.handleChangeAns13} />
               <label htmlFor="ans25">是</label>
               <input type="radio" value='1'
                id="ans26"
                checked={this.state.ans13 === '1'}
                onChange={this.handleChangeAns13} />
               <label htmlFor="ans26">否</label>
              </article>
              <article ref="toQ15">
               <h1>Q14:體重有明顯的下降趨勢，早上起來發現眼眶深陷，下巴骨突出?</h1>
               <input type="radio" value='5'
                id="ans27"
                checked={this.state.ans14 === '5'}
                onChange={this.handleChangeAns14} />
               <label htmlFor="ans27">是</label>
               <input type="radio" value='1'
                id="ans28"
                checked={this.state.ans14 === '1'}
                onChange={this.handleChangeAns14} />
               <label htmlFor="ans28">否</label>
              </article>
              <article ref="toQ16">
               <h1>Q15:感覺免疫力在下降，春、秋季流感一出現，自己首當其衝，難逃”流運” ?</h1>
               <input type="radio" value='5'
                id="ans29"
                checked={this.state.ans15 === '5'}
                onChange={this.handleChangeAns15} />
               <label htmlFor="ans29">是</label>
               <input type="radio" value='1'
                id="ans30"
                checked={this.state.ans15 === '1'}
                onChange={this.handleChangeAns15} />
               <label htmlFor="ans30">否</label>
              </article>
              <article ref="toNext5">
               <h1>Q16:性能力下降，妻子(或丈夫)對你明顯地表現了性要求，但卻沒有什麼慾望?</h1>
               <input type="radio" value='5'
                id="ans31"
                checked={this.state.ans16 === '5'}
                onChange={this.handleChangeAns16} />
               <label htmlFor="ans31">是</label>
               <input type="radio" value='1'
                id="ans32"
                checked={this.state.ans16 === '1'}
                onChange={this.handleChangeAns16} />
               <label htmlFor="ans32">否</label>
              </article>
              <div>{ nextBtn5 }</div>
              </div>
             </form>
            </section>
            </div>
          </div>
         </div>
        </div>
      </div>
    )
  }
}

export default Table1;

const Jeyu = {
  Banner: {
    background: 'url('+BG+') center center/ 120%',
    backgroundRepeat: 'no-repeat',
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  },
  Slogan: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    border: '5px solid #325aaa',
    textAlign: 'center',
    padding: '20px 40px',
    flexDirection: 'column'
  },
  tableBox: {
    background: '#e5d234'
  }
}



// WEBPACK FOOTER //
// ./src/Tables/table1.js